import { html } from "lit-element";
import { DrawSVGBaseModule } from "../../ModuleBase/svg-base-module";

export class DrawDecoVer2Module extends DrawSVGBaseModule {
	constructor(canvas) {
		super(canvas);

		this.name = "deco-ver-2";
		this.icon = svg_deco_ver_2;
	}
}

window.customElements.define("inspx-draw-deco-ver-2-module", DrawDecoVer2Module);

const svg_deco_ver_2 = html`
<svg width="45" height="90" xmlns="http://www.w3.org/2000/svg" xmlns:svg="http://www.w3.org/2000/svg">
 <g>
  <title>Layer 1</title>
  <rect stroke="#444444" id="svg_1" height="90" width="44.9502" y="0" x="0" fill="#ffffff"/>
  <line stroke="#444444" id="svg_2" y2="30" x2="44.41626" y1="30" x1="0" fill="none"/>
  <line stroke="#444444" id="svg_3" y2="60" x2="44.59424" y1="60" x1="0" fill="none"/>
  <rect stroke="#000000" stroke-width="0" id="svg_5" height="29.28303" width="44.36392" y="0.31296" x="0.15269" stroke-linecap="null" stroke-linejoin="null" stroke-dasharray="null" fill="#aaa7a7"/>
  <text fill="#000000" stroke-width="0" stroke-dasharray="null" stroke-linejoin="null" stroke-linecap="null" x="41.69337" y="63.04772" id="svg_6" font-size="24" font-family="Sans-serif" text-anchor="middle" xml:space="preserve" transform="matrix(0.6447996209498831,0,0,0.9600566543589287,-4.642872621085231,-7.394998887705053) " stroke="#000000">DECO</text>
 </g>
</svg>`;
